import React, { Component } from 'react';
import selectedIcon from '../../static/img/selected_icon.png'

class BookingService extends Component {

	render() {
		let { title, icon, isSelected } = this.props.bookingService

		return (
			<div className="BookingService" onClick={this.onClick}>
				<div className={"round" + (isSelected ? " selected" : "")}>
					{icon}
				</div>

				<div className={"title" + (isSelected ? " selected" : "")}>{title}</div>

				{this.renderSelectedIcon(isSelected)}
			</div>

		)
	}

	renderSelectedIcon = (isSelected) => {
		if (isSelected) {
			return (
				<img className="selected-icon" alt="" src={selectedIcon}/>
			)
		}

		return null
	}

	onClick = () => {
		this.props.onClick(this.props.bookingService)
	}

}

export default BookingService;


// WEBPACK FOOTER //
// ./src/components/bookingflow/BookingService.js